/**
 * Load all 3rd party imports here so it'll be
 * directly included in vendor.bundle.js file.
 */

//import '../node_modules/Sortable/Sortable.js';

// import 'expose-loader?$!../node_modules/jquery/dist/jquery.js';
import 'expose-loader?Sortable!../node_modules/Sortable/Sortable.js';
import 'expose-loader?moment!../node_modules/moment/moment.js';
import '../node_modules/stomp-websocket/lib/stomp.min.js';
import '../node_modules/sockjs-client/dist/sockjs.js';
import '../node_modules/bootstrap-daterangepicker/daterangepicker.js'

// import {angular} from '../node_modules/angular/angular.js';
// window.angular = angular;

import '../node_modules/angular/angular.js';

import '../node_modules/angular-utf8-base64/angular-utf8-base64.js';
import '../node_modules/angular-translate/dist/angular-translate.js';
import '../node_modules/angular-bootstrap/ui-bootstrap.js';
import '../node_modules/angular-local-storage/dist/angular-local-storage.js';
import '../node_modules/angular-loading-bar/build/loading-bar.js';
import '../node_modules/angular-moment/angular-moment.js';
import '../node_modules/angular-breadcrumb/release/angular-breadcrumb.js';

import '../node_modules/angular-dashboard-framework/dist/angular-dashboard-framework-tpls.js';
import './vendor/angular-dashboard-framework/structures.js';
import '../node_modules/highcharts-ng/dist/highcharts-ng.js';
import './vendor/time-picker/timepickerpop.js';
import '../node_modules/ngcontextmenu/dist/ngContextMenu.js';
import '../node_modules/angular-rangeslider/angular.rangeSlider.js';
import '../node_modules/angular-dynamic-locale/src/tmhDynamicLocale.js';
import './vendor/dsacomponents/dsacomponents.js';
import '../node_modules/angular-daterangepicker/js/angular-daterangepicker.js';
import '../node_modules/angular-toggle-switch/angular-toggle-switch.js';
import '../node_modules/angular-spinner/angular-spinner.js';
import '../node_modules/angular-scroll-glue/src/scrollglue.js';


import '../node_modules/angular-resource/angular-resource.js';
import '../node_modules/angular-cookies/angular-cookies.js';
import '../node_modules/angular-sanitize/angular-sanitize.js';
import '../node_modules/angular-touch/angular-touch.js';
import '../node_modules/angular-route/angular-route.js';
import '../node_modules/angular-animate/angular-animate.js';
import '../node_modules/angular-aria/angular-aria.js';
import '../node_modules/angular-messages/angular-messages.js';
import '../node_modules/angular-material/angular-material.js';
import '../node_modules/lodash/lodash.js';
import '../node_modules/restangular/dist/restangular.js';
import '../node_modules/angular-ui-router/release/angular-ui-router.js';



import '../node_modules/angular-translate-loader-static-files/angular-translate-loader-static-files.js';
import '../node_modules/angular-translate-loader-url/angular-translate-loader-url.js';


import '../node_modules/showdown/dist/showdown.js';
import '../node_modules/angular-markdown-directive/markdown.js';

import '../node_modules/highcharts/highcharts.js';
import '../node_modules/highcharts/highcharts-more.js';
import '../node_modules/highcharts/modules/exporting.js';

import '../node_modules/jquery-ui/jquery-ui.js';

import '../node_modules/d3/d3.js';
import '../node_modules/angular-bootstrap/ui-bootstrap-tpls.js';
import '../node_modules/bootstrap/dist/js/bootstrap.js';




import '../node_modules/underscore/underscore.js';
import '../node_modules/enquire/dist/enquire.js';


import '../node_modules/spin.js/spin.js';

// import '../node_modules/holderjs/holder.js';



import './vendor/exportFileSaver/FileSaver.js';
import './vendor/angular-dashboard-framework/widgets/news/news.js';
import './vendor/angular-dashboard-framework/widgets/weather/weather.js';
import './vendor/angular-dashboard-framework/widgets/linklist/linklist.js';
import './vendor/angular-dashboard-framework/widgets/markdown/markdown.js';

// import './vendor/modernizr/modernizr.js';




// WEBPACK FOOTER //
// ./src/vendor.module.js